function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "iconfinder_38-instagram_1161953",
  transform: "translate(-3.4 -4.8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_318",
  "data-name": "Trazado 318",
  d: "M20.406,16.7a5.006,5.006,0,1,0,5.006,5.006A5.016,5.016,0,0,0,20.406,16.7Zm0,8.213a3.207,3.207,0,1,1,3.207-3.207A3.222,3.222,0,0,1,20.406,24.913Z",
  transform: "translate(-7.307 -7.246)",
  fill: "#f50b0b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_60",
  "data-name": "Elipse 60",
  cx: 1.134,
  cy: 1.134,
  r: 1.134,
  transform: "translate(17.167 8.203)",
  fill: "#f50b0b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_319",
  "data-name": "Trazado 319",
  d: "M21.235,6.4a5.57,5.57,0,0,0-4.107-1.6H9.071A5.358,5.358,0,0,0,3.4,10.471v8.018a5.628,5.628,0,0,0,1.643,4.185A5.708,5.708,0,0,0,9.11,24.2h7.979A5.775,5.775,0,0,0,21.2,22.674a5.6,5.6,0,0,0,1.6-4.146V10.471A5.607,5.607,0,0,0,21.235,6.4Zm-.156,12.125a3.822,3.822,0,0,1-1.134,2.855A4.043,4.043,0,0,1,17.089,22.4H9.11a4.043,4.043,0,0,1-2.855-1.017A3.931,3.931,0,0,1,5.2,18.489V10.471A3.9,3.9,0,0,1,6.255,7.616,3.977,3.977,0,0,1,9.11,6.6h8.057a3.9,3.9,0,0,1,2.855,1.056,4.036,4.036,0,0,1,1.056,2.816v8.057Z",
  fill: "#f50b0b"
}));

var SvgInsta = function SvgInsta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.399,
    height: 19.399,
    viewBox: "0 0 19.399 19.399",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insta.68ffa19b.svg";
export { ForwardRef as ReactComponent };